import Vue from "vue";
import Router from "vue-router";
import { Route, RawLocation } from "vue-router/types";
import routeSwich from "@/services/RouteSwitch";
import store from "@/store";
import VueGtag from "vue-gtag";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "root",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Auth/Login.vue"),
      meta: { public: true },
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Auth/Login.vue"),
      meta: { public: true },
    },
    {
      path: "/sso",
      name: "sso",
      component: () =>
        import(/* webpackChunkName: "sso" */ "./views/Auth/LoginSso.vue"),
      meta: { public: true },
    },
    {
      path: "/forgot",
      name: "forgot",
      component: () =>
        import(
          /* webpackChunkName: "forgot" */ "./views/Auth/RecoveryPassword.vue"
        ),
      meta: { public: true },
    },
    {
      path: "/logout",
      name: "logout",
      component: () =>
        import(/* webpackChunkName: "logout" */ "./views/Auth/Logout.vue"),
    },
    {
      path: "/home-room",
      name: "home-room",
      component: () =>
        import(/* webpackChunkName: "home-room" */ "./views/HomeRoom.vue"),
    },
    {
      path: "/assessment/:subject?/:testNumber?/:number?",
      name: "assessment",
      props: true,
      component: () =>
        import(/* webpackChunkName: "assessment" */ "./views/Assessment.vue"),
    },
    {
      path: "/assessment-wait",
      name: "assessment-wait",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "assessment-wait" */
          "./views/AssessmentWait.vue"
        ),
    },
    {
      path: "/assessment-done",
      name: "assessment-done",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "assessment-done" */
          "./views/AssessmentDone.vue"
        ),
    },
    {
      path: "/practice",
      name: "practice",
      redirect: "/practice/login",
      component: () =>
        import(
          /* webpackChunkName: "practice" */ "./views/Practice/Practice.vue"
        ),
      meta: { public: true },
      children: [
        {
          path: "login",
          name: "practice-login",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "practice-login" */ "@/views/Practice/PracticeLogin.vue"
            ),
          meta: { public: true },
        },
        {
          path: "wait",
          name: "practice-wait",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "practice-wait" */ "@/views/Practice/PracticeWait.vue"
            ),
          meta: { public: true },
        },
        {
          path: "done",
          name: "practice-done",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "practice-done" */ "@/views/Practice/PracticeDone.vue"
            ),
          meta: { public: true },
        },
        {
          path: "assessment/:subject?",
          name: "practice-assessment",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "practice-assessment" */ "@/views/Practice/PracticeAssessment.vue"
            ),
          meta: { public: true },
        },
      ],
    },
    {
      path: "/demo",
      name: "demo",
      redirect: "/demo/login",
      component: () =>
        import(/* webpackChunkName: "demo" */ "./views/Demo/Demo.vue"),
      meta: { public: true },
      children: [
        {
          path: "login",
          name: "demo-login",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "demo-login" */ "@/views/Demo/DemoLogin.vue"
            ),
          meta: { public: true },
        },
        {
          path: "wait",
          name: "demo-wait",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "demo-wait" */ "@/views/Demo/DemoWait.vue"
            ),
          meta: { public: true },
        },
        {
          path: "done",
          name: "demo-done",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "demo-done" */ "@/views/Demo/DemoDone.vue"
            ),
          meta: { public: true },
        },
        {
          path: "assessment/:subject?",
          name: "demo-assessment",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "demo-assessment" */ "@/views/Demo/DemoAssessment.vue"
            ),
          meta: { public: true },
        },
      ],
    },
  ],
});

async function beforeEachNewCall(
  to: Route,
  from: Route,
  next: (to?: RawLocation) => void
): Promise<void> {
  try {
    // This is the entire problem with the scroll
    document.body.className = document.body.className.replace("modal-open", "");
  } catch (err) {}

  if (to.name === "sso") {
    store.commit("authModule/setLogout");
  }

  const isPublic = to.matched.some(m => m.meta.public);
  const isLogged = store.getters["authModule/isLogged"];

  if (!isLogged) {
    store.commit("authModule/setLogout");
  }

  if (to.name === "logout" || (isPublic && !isLogged)) {
    next();
  } else if (isLogged) {
    await routeSwich.next(to, from, next);
  } else {
    next("/login");
  }
}

// Added authentication guard.
router.beforeEach(beforeEachNewCall);

// Gtag
Vue.use(
  VueGtag,
  {
    config: { id: "UA-171696861-1" },
  },
  router
);

export default router;
